










































import { Vue, Component } from 'vue-property-decorator';
import scaleEl from '@/util/scale';
import { checkIsPc, checkIsMobile, device } from '@/util/mediaCheck';
@Component
export default class WeHeader extends Vue {
  public device = device;
  // 点击weremit图标返回首页
  handleLogoClick() {
    if (checkIsPc()) {
      this.$emit('logoClick');
    } else if (checkIsMobile()) {
      // 如果不加catch error，会有路由重复的问题
      this.$router.push('/').catch((err) => {});
    }
  }
}
